import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip } from 'syngenta-digital-cropwise-react-ui-kit';
import 'screens/Integrations/components/integrationTooltip.css';

import FarmIcon from '../../../../../components/icons/FarmIcon';

const propertiesDefaultPropPropertiesNames = [];
const Properties = ({
  propertiesNames = propertiesDefaultPropPropertiesNames,
  propertiesCount = null,
  propertiesArea = null
}) => (
  <Tooltip
    overlayClassName="integration-tooltip"
    placement="top"
    align={{ offset: [0, 6] }}
    color="#232630"
    overlayStyle={{ maxWidth: 'none' }}
    title={
      <div className="text-xs text-white" style={{ width: '10rem' }}>
        {propertiesNames.join(', ')}
      </div>
    }
  >
    <div
      className="flex flex-col w-fit justify-start"
      data-testid="hover-properties-name"
    >
      <div className="text-sm flex align-center">
        <FarmIcon />
        <span className="ml-1">
          {`${propertiesCount} ${
            propertiesCount > 1 ? 'properties' : 'property'
          }`}
        </span>
      </div>
      <span className="text-xs text-neutral-60 text-left">
        {propertiesArea?.toFixed(2)} ac
      </span>
    </div>
  </Tooltip>
);

Properties.propTypes = {
  propertiesNames: PropTypes.arrayOf(PropTypes.string),
  propertiesCount: PropTypes.number,
  propertiesArea: PropTypes.number
};

export default Properties;
